// HighLowVolatilityChart.jsx
import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import axios from "axios";
import {fetchTable} from "../../api";

export default function HighLowVolatilityChart() {
  const [dataReady, setDataReady] = useState(null);

  useEffect(() => {
    fetchTable("intraday_vol",'n50').then((res) => {
      // const symbols = res.data.map((d) => d.symbol);
      const symbols = res.map((d) => d.symbol);
      // const volatility = res.data.map((d) => d.volatility_pct);
      const volatility = res.map((d) => d.volatility_pct);

      setDataReady({ symbols, volatility });
    });
  }, []);

  if (!dataReady) return <div>Loading Volatility Tracker...</div>;

  return (
    <Plot
      data={[
        {
          type: "bar",
          orientation: "h",
          x: dataReady.volatility,
          y: dataReady.symbols,
          text: dataReady.volatility.map((v) => v.toFixed(2) + "%"),
          textposition: "auto",
          marker: {
            color: dataReady.volatility,
            colorscale: "Reds",
            showscale: true,
            colorbar: { title: "Volatility %" },
          },
        },
      ]}
      layout={{
        title: "Today's High–Low Range Tracker (Top 20 Volatile Stocks)",
        xaxis: { title: "Intraday Volatility (%)" },
        yaxis: { automargin: true,autorange: "reversed"  },
        margin: { l: 100, r: 20, t: 50, b: 50 },
        height: 650,
      }}
      style={{ width: "100%" }}
    />
  );
}

